import React from "react";
import MembershipBenefits from "./membershipBenefits";
import { useNavigate } from "react-router-dom"; // ✅ Import navigate
import "./membership.css";

const MembershipPage = () => {
  const navigate = useNavigate(); // ✅

  return (
    <div className="membership-container">
      <h1>Join as a Premium Member</h1>
      <p className="membership-intro">
        Step forward to support a noble cause through education, research, and self-discovery.
      </p>

      <MembershipBenefits />

      <button className="apply-button" onClick={() => navigate("/membership/form")}>
        Apply Now
      </button>
    </div>
  );
};

export default MembershipPage;
